import { forwardRef, type HTMLAttributes } from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cn } from '@shared/lib/cn';

/**
 * Restrained card surface. Hairline border + soft small shadow by default;
 * elevated shadow available via `elevated` for floating contexts (modals
 * pre-sheet, hero panels).
 */
interface CardProps extends HTMLAttributes<HTMLDivElement> {
  asChild?: boolean;
  elevated?: boolean;
  /** Disable paper grain — useful inside data-dense screens. */
  noGrain?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { className, asChild, elevated, noGrain, ...props },
  ref,
) {
  const Comp = asChild ? Slot : 'div';
  return (
    <Comp
      ref={ref}
      className={cn(
        'rounded-xl bg-card hairline shadow-sm p-5',
        elevated && 'shadow-elevated',
        !noGrain && 'paper-grain',
        className,
      )}
      {...props}
    />
  );
});
